export default "__VITE_ASSET__xq41n8lB__"